import manageType from '@shared/manage/manage-enum';
import roles from '@security/roles';

function RolesFactory() { }


// Our Factory method for creating new Roles instances
RolesFactory.prototype.createRoles = function (options) {
    var values = {}

    switch (options.manageType) {

        case manageType.values.ADMIN:
            values = { admin: roles.values.admin }
            break;

        case manageType.values.PROPERTY:
            values = { propertyManager: roles.values.propertyManager }
            break;

        case manageType.values.SUBPROPERTY:
            values = { subpropertyManager: roles.values.subpropertyManager }
            break;

        case manageType.values.PROGRAM:
            values = { programManager: roles.values.programManager }
            break;

        case manageType.values.SUBPROGRAM:
            values = { subprogramManager: roles.values.subprogramManager }
            break;

        default:
            // throw (`unknow manageType ${manageType} unknow`);
            break
     }

    return values;
};

export default RolesFactory;